import React, { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

const AVReactPlayer = ({ url, startTime, onProgress }) => {
    const playerRef = useRef(null);
    const [audioUrl, setAudioUrl] = useState('');

    useEffect(() => {
        setAudioUrl(url);
    }, [url]);

    let videoWidth = '1000px'; // Default video width

    const screenWidth = window.innerWidth;
    if (screenWidth < 400) {
        // Mobile screen
        videoWidth = '320px';
    } else if (screenWidth < 768) {
        // Mobile screen
        videoWidth = '600px';
    } else if (screenWidth < 1024) {
        // Tablet screen
        videoWidth = '800px';
    }

    const handleProgress = ({ playedSeconds }) => {
        onProgress(playedSeconds);
    };

    const handleDuration = (duration) => {
        // Handle duration if needed
    };

    const handleBufferEnd = () => {
        // Buffering complete
        console.log('Buffering complete');
    };

    useEffect(() => {
        if (playerRef.current && typeof startTime === 'number') {
            playerRef.current.seekTo(startTime);
        }
    }, [startTime]);

    return (
        <div className="flex justify-center items-center h-full">
            <div style={{ width: videoWidth, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ReactPlayer
                    ref={playerRef}
                    url={audioUrl}
                    controls
                    width="90%"
                    height="100px"
                    onProgress={handleProgress}
                    onDuration={handleDuration}
                /* onBufferEnd={handleBufferEnd}
                progressInterval={1000} // Update progress interval as per your requirement
                config={{
                    file: {
                        attributes: {
                            preload: 'auto', // Preload the video
                        },
                    },
                }} */
                />
            </div>
        </div>
    );
};

export default AVReactPlayer;
